import React, { useState } from "react";
import {
  FormFeedback,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import actions from "../../redux/actions";
import { showError } from "../../utilities/alerts/toastAlerts";
import validateInput from "../../utilities/validations/emptyValidator";
export default function EditVitals({
  modalVisible,
  toggleModal,
  onAddEditomplete,
  isEdit,
  editData = {},
}) {
  const [state, setState] = React.useState({
    name: "",
    code: "",
    measuringUnit: "",
    comment: "",
    ...editData,
  });
  console.log(editData, "th ei");
  const [errorObj, setErrorData] = useState({});
  const updateState = (data) => setState((val) => ({ ...val, ...data }));

  const onChangeText = (e) => {
    if (errorObj[e.target.name]) {
      setErrorData((data) => ({ ...data, [e.target.name]: "" }));
    }
    updateState({ [e.target.name]: e.target.value });
  };

  const onOptionSubmit = () => {
    const { isValid, errors } = validateInput({
      name: { value: state.name, name: "Name" },
      code: { value: state.code, name: "Code" },
      measuringUnit: { value: state.measuringUnit, name: "Measuring Unit" },
      comment: { value: state.comment, name: "Comment" },
    });

    console.log(errors, "the errors data value");
    if (!isValid) {
      setErrorData(errors);
      return;
    } else {
      actions
        .addEditVitalParam({
          ...state,
        })
        .then((res) => {
          console.log(res, "the response value");
          onAddEditomplete();
        })
        .catch((error) => {
          console.log(error, "the error value");
          //   setIsLoading(false);
          showError(error);
        });
    }
  };

  console.log(errorObj, "the errA");
  console.log(state.code + "asd");
  return (
    <Modal centered isOpen={modalVisible} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>{`${
        isEdit ? "Edit" : "Add"
      } Vital Parameter`}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <label>Name</label>
          <Input
            name={"name"}
            onChange={onChangeText}
            value={state.name}
            invalid={!!errorObj.name}
            type="text"
          />
          <FormFeedback>{errorObj.name}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <label>Vital Code</label>
          <Input
            name={"code"}
            onChange={onChangeText}
            value={state.code}
            invalid={!!errorObj.code}
            type="text"
          />
          <FormFeedback>{errorObj.code}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <label>Measuring Unit</label>
          <Input
            name={"measuringUnit"}
            onChange={onChangeText}
            value={state.measuringUnit}
            invalid={!!errorObj.measuringUnit}
            type="text"
          />
          <FormFeedback>{errorObj.measuringUnit}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <label>Comment</label>
          <Input
            name={"comment"}
            onChange={onChangeText}
            value={state.comment}
            invalid={!!errorObj.comment}
          />
          <FormFeedback>{errorObj.comment}</FormFeedback>
        </FormGroup>

        <div
          className="create-btn"
          style={{ textDecoration: "none", width: 100, textAlign: "center" }}
          onClick={onOptionSubmit}
        >
          Submit
        </div>
      </ModalBody>
    </Modal>
  );
}
